/**
 * FlexiPage Theme
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
function rewriteEmails() {
    var rewriteLink = function (linkEl) {
        var address = linkEl.innerText.replace(/(\(zavinac\)|&#64;)/g, '@');
        var label = address.replace(/@/g, '&#64;');
        linkEl.innerHTML = linkEl.innerHTML.replace(/[\w\.-_]+(\(zavinac\)|&#64;)[\w\.-_]+(\.[\w\.-_]+)?/, label);
        linkEl.setAttribute('href', 'mailto:' + address.trim());
    };
    var links = document.body.querySelectorAll('a[href="#mail-link"]');
    for (var i = 0; i < links.length; i++)
        rewriteLink(links.item(i));
}
exports.rewriteEmails = rewriteEmails;
;



/*****************
 ** WEBPACK FOOTER
 ** ./ts/email.ts
 ** module id = 3
 ** module chunks = 0
 **/